import { cloneElement, useEffect, useState, useRef } from 'react';
import style from './AccordionBase.module.scss';

const AccordionBase = ({ children, onChangeActiveItem, className = '' }) => {
  let defaultActiveItem = null;

  children.forEach((child) => {
    if (child.props.active) {
      defaultActiveItem = child.props;
    }
  });

  const [activeItemId, setActiveItemId] = useState(defaultActiveItem ? defaultActiveItem.id : null);
  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      onChangeActiveItem(activeItemId);
    }
  }, [activeItemId]);

  return (
    <div className={`${style.accordion} ${className}`}>
      {children.map((child) => {
        return cloneElement(child, {
          key: child.props.id,
          isActive: child.props.id === activeItemId,
          onClick: () => setActiveItemId(child.props.id),
        });
      })}
    </div>
  );
};

export default AccordionBase;
